(() => {
  const configNode = document.getElementById('ForgeDirectConfig');
  if (!configNode || window.forgeDirectReady) return;
  window.forgeDirectReady = true;
  const cfg = JSON.parse(configNode.textContent);
  const base = (cfg.root || '/').replace(/\/?$/, '/');
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:cfg.currency || 'USD'}).format(value / 100);
  const $ = (selector, root = document) => root.querySelector(selector);
  const make = (tag, text, className) => {const el=document.createElement(tag);if(text != null) el.textContent=text;if(className) el.className=className;return el;};
  const dialog = $('#ForgeCart');
  const easel = cfg.stand?.variants?.find(v => v.title === 'Fold-Flat Hidden Easel');
  let lastFocus, pending = false, cart = null;
  const cartError = $('[data-cart-error]');
  const api = async (path, data) => {
    const response = await fetch(base + path, {method:data ? 'POST':'GET', headers:{'Accept':'application/json', ...(data ? {'Content-Type':'application/json'}:{})}, credentials:'same-origin', ...(data ? {body:JSON.stringify(data)}:{})});
    const result = await response.json();
    if(!response.ok || result.status >= 400) throw new Error(result.description || cfg.text.error);
    return result;
  };
  function setBusy(value) {
    pending=value;
    dialog?.setAttribute('aria-busy',String(value));
    dialog?.querySelectorAll('input,button[name=checkout],.fd-remove').forEach(el=>el.disabled=value);
    if(!value && !cart?.item_count) $('[data-drawer-checkout]').disabled=true;
    document.querySelectorAll('[data-product-root] .buy-button').forEach(el=>{el.disabled=value || el.dataset.available !== 'true';});
    document.dispatchEvent(new CustomEvent('forge:cart-busy',{detail:{busy:value}}));
  }
  function openCart() {
    if(!dialog) return;
    lastFocus=document.activeElement;
    if(!dialog.open) dialog.showModal();
    document.documentElement.style.overflow='hidden';
    $('[data-cart-close]').focus();
  }
  function closeCart() {dialog.close();}
  dialog?.addEventListener('close',()=>{document.documentElement.style.overflow='';lastFocus?.focus?.();});
  $('[data-cart-close]')?.addEventListener('click',closeCart);
  dialog?.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left || event.clientX>rect.right)closeCart();}});
  function renderCart(value) {
    cart=value;cfg.currency=value.currency || cfg.currency;
    const list=$('[data-cart-lines]');list.replaceChildren();
    if(!value.items.length) list.append(make('p',cfg.text.empty,'fd-muted'));
    for(const item of value.items) {
      const article=make('article',null,'fd-cart-item');
      const link=make('a');link.href=item.url;
      if(item.image){const img=make('img');img.src=item.image;img.alt=item.product_title;img.width=76;img.height=90;link.append(img);}
      const body=make('div');const title=make('h3');const name=make('a',item.product_title);name.href=item.url;title.append(name);
      body.append(title,make('p',item.variant_title || ''),make('strong',money(item.final_line_price)));
      if(item.line_level_discount_allocations?.length) body.append(make('p',item.line_level_discount_allocations.map(d=>d.discount_application.title).join(', ')));
      const controls=make('div',null,'flex items-center justify-between gap-3');
      const label=make('label',cfg.text.quantity+' ');const quantity=make('input');quantity.type='number';quantity.min='0';quantity.step='1';quantity.value=item.quantity;quantity.setAttribute('aria-label',cfg.text.quantity+' '+item.product_title);quantity.dataset.cartKey=item.key;
      quantity.addEventListener('change',()=>{if(!quantity.checkValidity())return quantity.reportValidity();change(item.key,Number(quantity.value));});
      label.append(quantity);const remove=make('button',cfg.text.remove,'fd-remove');remove.type='button';remove.addEventListener('click',()=>change(item.key,0));controls.append(label,remove);body.append(controls);article.append(link,body);list.append(article);
    }
    $('[data-cart-total]').textContent=money(value.total_price);
    document.querySelectorAll('.cart-link span').forEach(el=>el.textContent=value.item_count);
    const progress=$('[data-shipping-progress]');
    const show=(cfg.review || cfg.shippingEnabled) && cfg.country==='US' && cfg.currency==='USD' && cfg.threshold > 0;
    progress.hidden=!show;
    if(show) {
      const missing=Math.max(0,cfg.threshold-value.total_price);
      $('p',progress).textContent=missing ? cfg.text.remaining.replace('[amount]',money(missing)) : cfg.text.qualified;
      $('progress',progress).value=Math.min(100,100*value.total_price/cfg.threshold);
      $('small',progress).textContent=cfg.review ? cfg.text.preview : cfg.text.terms;
    }
    const accessory=value.items.find(i=>i.properties?._forge_accessory==='drawer-easel');
    const compatible=value.items.some(i=>i.properties?._forge_easel_compatible==='yes');
    const alreadyHasEasel=value.items.some(i=>i.id===easel?.id);
    $('[data-cart-upsell]').hidden=!(easel?.available && (accessory || (compatible && !alreadyHasEasel)));
    $('[data-cart-easel]').checked=!!accessory;
    $('[data-easel-price]').textContent=easel ? money(easel.price):'';
    $('[data-drawer-checkout]').disabled=!value.item_count || pending;
    document.dispatchEvent(new CustomEvent('forge:cart-updated',{detail:{itemCount:value.item_count}}));
  }
  async function refreshCart(){renderCart(await api('cart.js'));}
  async function mutate(operation, errorElement=cartError) {
    if(pending)return;
    setBusy(true);errorElement.textContent='';cartError.textContent='';
    try{await operation();await refreshCart();$('#ForgeCartStatus').textContent=cfg.text.added;}
    catch(error){errorElement.textContent=error.message || cfg.text.error;try{await refreshCart();}catch{}}
    finally{setBusy(false);}
  }
  async function change(key,quantity){await mutate(()=>api('cart/change.js',{id:key,quantity}));}
  $('[data-cart-easel]')?.addEventListener('change',async event=>{
    const existing=cart?.items.find(i=>i.properties?._forge_accessory==='drawer-easel');
    if(event.target.checked)await mutate(()=>api('cart/add.js',{items:[{id:easel.id,quantity:1,properties:{_forge_accessory:'drawer-easel'}}]}));
    else if(existing)await change(existing.key,0);
  });
  document.addEventListener('click',async event=>{
    const link=event.target.closest('.cart-link');
    if(!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey)return;
    event.preventDefault();openCart();cartError.textContent='';
    setBusy(true);try{await refreshCart();}catch(error){cartError.textContent=cfg.text.error;}finally{setBusy(false);}
  });
  function initializeProduct(root) {
    if(root.dataset.fdReady)return;
    const source=$('[data-variant-id]',root), payload=$('[data-product-json]',root), namesPayload=$('[data-options-json]',root);
    if(!source || !payload || !namesPayload)return;
    root.dataset.fdReady='true';
    const variants=JSON.parse(payload.textContent), names=JSON.parse(namesPayload.textContent);
    const container=$('[data-option-controls]',root), form=$('.product-form',root), add=$('.buy-button',root), addon=$('[data-easel-addon]',root), check=$('[data-pdp-easel]',root), error=$('[data-product-error]',root);
    const sizePattern=/^(5\s*[x×]\s*7|8\s*[x×]\s*10|12\s*[x×]\s*16)(\b|\s|$)/i;
    const sizeIndex=names.findIndex((n,i)=>variants.every(v=>sizePattern.test(v.options[i])));
    const none=value=>/^(artwork only|no frame|none|unframed)$/i.test(value);
    const frameIndex=names.findIndex((n,i)=>i!==sizeIndex && /frame|display/i.test(n) && variants.some(v=>none(v.options[i])));
    const order=names.map((_,i)=>i);if(sizeIndex>=0){order.splice(order.indexOf(sizeIndex),1);order.unshift(sizeIndex);}
    let current=variants.find(v=>String(v.id)===source.value)||variants[0], selected=[...current.options], compatible=false;
    let framePreference=frameIndex>=0 ? selected[frameIndex]:null;
    const quantity=()=>Math.max(1,Number($('[name=quantity]',form).value)||1);
    function totals(){
      const qty=quantity();const total=(current?.price||0)+(check?.checked && compatible ? easel.price:0);
      $('[data-configuration-total]',root).textContent=cfg.product.total+' '+money(total*qty);
      const accelerated=$('.shopify-payment-button',form);
      if(accelerated)accelerated.hidden=!current?.available || !!check?.checked;
      root.dispatchEvent(new CustomEvent('forge:selection-change',{detail:{variant:current,options:names,total:total*qty}}));
    }
    function render(updateUrl=true) {
      container.replaceChildren();
      if(!(variants.length===1 && variants[0].title==='Default Title')) {
        for(let step=0;step<order.length;step++){
          const index=order[step], prior=order.slice(0,step);
          let candidates=variants.filter(v=>prior.every(i=>v.options[i]===selected[i]));
          if(index===frameIndex && /^12\s*[x×]\s*16/i.test(selected[sizeIndex])) candidates=candidates.filter(v=>none(v.options[index]));
          const values=[...new Set(candidates.map(v=>v.options[index]))];
          if(!values.includes(selected[index])) selected[index]=values.find(value=>candidates.some(v=>v.options[index]===value&&v.available))||values[0];
          const field=make('fieldset',null,'fd-options');field.append(make('legend',index===sizeIndex ? root.dataset.sizeLabel:index===frameIndex ? root.dataset.frameLabel:names[index]));
          const grid=make('div',null,'fd-option-grid');
          for(const value of values) {
            const matches=candidates.filter(v=>v.options[index]===value);
            const available=matches.some(v=>v.available);
            const button=make('button',value,'fd-option');button.type='button';button.disabled=!available;button.setAttribute('aria-pressed',String(selected[index]===value));
            const exact=matches.find(v=>v.options.every((x,i)=>i===index || x===selected[i]));
            const price=exact?.price ?? Math.min(...matches.map(v=>v.price));
            let label=money(price);
            if(index===frameIndex){const plain=candidates.find(v=>none(v.options[index]));if(plain) label=none(value)? cfg.product.included:'+'+money(price-plain.price);}
            if(index===sizeIndex || index===frameIndex)button.append(make('small',available ? label:root.dataset.soldOut));
            button.addEventListener('click',()=>{selected[index]=value;if(index===frameIndex)framePreference=value;else if(frameIndex>=0 && framePreference)selected[frameIndex]=framePreference;render();const focus=[...container.querySelectorAll('button')].find(b=>b.dataset.index===String(index)&&b.dataset.value===value);focus?.focus();});
            button.dataset.index=index;button.dataset.value=value;grid.append(button);
          }
          field.append(grid);container.append(field);
        }
      }
      current=variants.find(v=>v.options.every((value,i)=>value===selected[i]));
      source.value=current ? String(current.id):'';
      $('[data-price]',root).textContent=current ? money(current.price):root.dataset.unavailable;
      add.dataset.available=String(!!current?.available);add.disabled=!current?.available || pending;add.textContent=current?.available?root.dataset.add:root.dataset.soldOut;
      compatible=false;
      if(easel?.available && frameIndex>=0 && sizeIndex>=0 && current?.available) {
        const size=selected[sizeIndex].replace(/\s/g,'').replace(/×/g,'x');
        compatible=size==='5x7' || (size==='8x10' && none(selected[frameIndex]));
      }
      if(addon){addon.hidden=!compatible;if(!compatible)check.checked=false;const p=$('[data-pdp-easel-price]',root);if(p)p.textContent=easel ? '+'+money(easel.price):'';}
      totals();
      const mediaId=source.selectedOptions[0]?.dataset.imageId;
      if(mediaId){const gallery=$('.product-gallery',root),media=[...gallery.children].find(el=>el.dataset.mediaId===mediaId);if(media && !gallery.hasAttribute('data-forge-gallery'))gallery.prepend(media);}
      if(updateUrl && current){const url=new URL(location.href);url.searchParams.set('variant',current.id);history.replaceState({},'',url);}
    }
    render(false);container.hidden=false;$('[data-variant-fallback]',root).hidden=true;
    check?.addEventListener('change',totals);$('[name=quantity]',form).addEventListener('input',totals);
    window.addEventListener('popstate',()=>{const id=new URL(location.href).searchParams.get('variant');const variant=variants.find(v=>String(v.id)===id);if(variant){selected=[...variant.options];framePreference=frameIndex>=0?selected[frameIndex]:null;render(false);}});
    form.addEventListener('submit',async event=>{
      event.preventDefault();if(!form.reportValidity() || !current?.available || pending)return;
      const properties={};new FormData(form).forEach((value,key)=>{const match=key.match(/^properties\[(.*)\]$/);if(match)properties[match[1]]=String(value);});
      if(compatible)properties._forge_easel_compatible='yes';
      const items=[{id:current.id,quantity:quantity(),properties}];
      if(check?.checked && compatible)items.push({id:easel.id,quantity:quantity(),properties:{_forge_accessory:'pdp-easel',_forge_pair:String(current.id)}});
      await mutate(()=>api('cart/add.js',{items}),error);
      if(!error.textContent)openCart();
    });
  }
  cfg.product=JSON.parse($('#ForgeProductText')?.textContent || '{}');
  document.querySelectorAll('[data-product-root]').forEach(initializeProduct);
  function initializeWizard(root) {
    if(root.dataset.ready)return;root.dataset.ready='true';
    const form=$('form',root),steps=[...root.querySelectorAll('[data-step]')],text=JSON.parse($('[data-wizard-text]',root).textContent),error=$('[data-wizard-error]',root);
    let index=0;
    const submit=$('[data-wizard-submit]',root),next=$('[data-wizard-next]',root),back=$('[data-wizard-back]',root);
    form.dataset.enhanced='true';form.noValidate=true;
    function show(focus=false){
      steps.forEach((step,i)=>step.hidden=i!==index);back.hidden=index===0;next.hidden=index===3;submit.hidden=index!==3;
      $('[data-wizard-progress]',root).textContent=text.step.replace('[number]',index+1);
      if(focus)steps[index].querySelector('input,textarea,select')?.focus();
    }
    function validStep(){
      for(const input of steps[index].querySelectorAll('input,select,textarea')){
        if(!input.checkValidity()){show(true);input.reportValidity();return false;}
      }return true;
    }
    next.addEventListener('click',()=>{if(validStep()){index++;show(true);}});
    back.addEventListener('click',()=>{index=Math.max(0,index-1);show(true);});
    const deadline=$('[name="contact[Deadline]"]',form),now=new Date();
    deadline.min=new Date(now.getTime()-now.getTimezoneOffset()*60000).toISOString().slice(0,10);
    form.addEventListener('submit',event=>{
      error.textContent='';
      if(index<3){event.preventDefault();if(validStep()){index++;show(true);}return;}
      for(let i=0;i<steps.length;i++){index=i;if(!validStep()){event.preventDefault();return;}}
      index=3;show();
      if($('[name=website]',form).value){event.preventDefault();error.textContent=text.error;return;}
      steps.forEach(step=>step.hidden=false);
    });
    show();
  }
  document.querySelectorAll('[data-commission]').forEach(initializeWizard);
  document.addEventListener('shopify:section:load',event=>{event.target.querySelectorAll('[data-product-root]').forEach(initializeProduct);event.target.querySelectorAll('[data-commission]').forEach(initializeWizard);});
})();

